import {
    ComponentElements,
    ComponentInjector,
    ComponentObject,
    ComponentService,
    UIComponent,
    ComponentSelectors,
    ComponentSelector,
    Inject,
    BrowserUtils
} from '@atypon/ui-utils';

class Texts extends ComponentObject { }

class ClassList extends ComponentObject { }

class Selectors extends ComponentSelectors {
    closeBTN = new ComponentSelector('.closeBTN')
}

class Elements extends ComponentElements<Selectors> {
    closeBTN: HTMLElement;
}

interface ShowRecommendedPopup extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class ShowRecommendedPopup implements UIComponent {

    @Inject()
    protected browserUtils: BrowserUtils;

    constructor(readonly wrapper: HTMLElement) { }

    initialize = (): void => {
        this.elements.initialize(this.wrapper);
        this.addEventListeners();
    }

    addEventListeners = (): void => {
        window.addEventListener('scroll', this.handleShowPopup);
        
        this.elements.closeBTN.addEventListener("click", () => {
            this.closePopup()
        })
    }

    showPopup = (): void => {
        this.elements.wrapper.style.display = "block";
    }

    hidePopup = (): void => {
        this.elements.wrapper.style.display = "none";
    }

    closePopup = (): void => {
        this.elements.wrapper.remove();
    }

    handleShowPopup = (): void => {
        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        var bodyHeight = document.body.scrollHeight * 0.5
        if (scrollPosition > bodyHeight) {
            this.showPopup();
        } else {
            this.hidePopup();
        }
    }
}

export default ShowRecommendedPopup;

export {
    Elements as ShowRecommendedPopupElements,
    Selectors as ShowRecommendedPopupSelectors,
    ClassList as ShowRecommendedPopupClassList,
    Texts as ShowRecommendedPopup
}
